import styled from '@emotion/styled';

const ActionBar = styled.nav`
  background: rgba(255, 255, 255, 0.065);
  border-radius: ${(props) => props.theme.border.radius};
  padding: 0.5rem 1rem;
`;

export default ActionBar;
